// import {getRequest} from './api'
import {Message} from 'element-ui'
import ct from './constant.js'

export const isNotNullORBlank = (...args) => {
  for (let i = 0; i < args.length; i++) {
    let argument = args[i]
    if (argument === null || argument === '' || argument === undefined) {
      Message.warning({message: '数据不能为空!'})
      return false
    }
  }
  return true
}

export const setStorage = (name, content) => {
  if (!name) return
  if (typeof content !== 'string') {
    content = JSON.stringify(content)
  }
  window.localStorage.setItem(name, content)
}

export const getStorage = (name) => {
  if (!name) return
  let item = window.localStorage.getItem(name)
  if (!item) return
  if (!isJsonString(item)) return item
  return JSON.parse(item)
}

export const isJsonString = (str) => {
  try {
    if (typeof JSON.parse(str) === 'object') {
      return true
    }
  } catch (e) {
  }
  return false
}

export const dtFormat = (dt) => {
  let month = dt.month + 1
  return dt.year + '-' + month + '-' + dt.dayOfMonth + ' ' + dt.hourOfDay + ':' + dt.minute + ':' + dt.second
}

const stringSplit = (name, tar) => {
  let n = []
  let indexLast = name.lastIndexOf(tar)
  let fir = name.substring(0, indexLast + 1)
  n.push(fir.substring(0, fir.length - 1))
  let last = name.substring(indexLast + 1, name.length)
  n.push(last)
  return n
}

export const repeatNameHandler = (name, isFile, _this) => {
  if (isFile) {
    let idxList = []
    // let n = name.split('.')
    // let m = name.split('.')[name.split('.').length-1]
    // console.log('repeatNameHandler', name)
    let n = stringSplit(name, '.')
    let repeatList = []
    if (n[0]) {
      _this.filesList.forEach(el => {
        let fn = stringSplit(el.fileName, '.')
        if (fn[0].indexOf(n[0]) > -1 && fn[1] === n[1]) {
          repeatList.push(fn[0])
        }
      })
    }
    if (repeatList.length === 0) {
      return name
    }
    repeatList.forEach(l => {
      if (l.lastIndexOf('(') > -1 && l.lastIndexOf(')') > -1) {
        let strs = stringSplit(l, '(')
        if (strs[1]) {
          let s = stringSplit(strs[1], ')')
          let idx = parseInt(s[0])
          if (idx) {
            idxList.push(idx)
          } else {
            idxList.push(0)
          }
        } else {
          idxList.push(0)
        }
      } else {
        idxList.push(0)
      }
    })
    idxList = idxList.sort((x, y) => x - y)
    let str = n[1] === undefined ? '' : '.' + n[1]
    name = n[0] + '(' + (idxList.pop() + 1) + ')' + str
  } else {
    let repeatList = []
    _this.filesList.forEach(el => {
      if (el.fileName.indexOf(name) > -1) {
        repeatList.push(el.fileName)
      }
    })
    if (repeatList.length === 0) {
      return name
    }
    // console.log('repeatNameHandler')
    let idxList = []
    repeatList.forEach(el => {
      if (el.indexOf('(') > -1 && el.indexOf(')') > -1) {
        let strs = el.split('(')
        if (strs[1]) {
          let s = strs[1].split(')')
          let idx = parseInt(s[0])
          if (idx) {
            idxList.push(idx)
          } else {
            idxList.push(0)
          }
        } else {
          idxList.push(0)
        }
      } else {
        idxList.push(0)
      }
    })
    idxList = idxList.sort((x, y) => x - y)
    name = name + '(' + (idxList.pop() + 1) + ')'
  }
  return name
}

export const getUrlParamHref = (val) => {
  // let uri = window.location.href
  // let re = new RegExp('' + val + '=([^&?]*)', 'ig')
  // return ((uri.match(re)) ? (uri.match(re)[0].substr(val.length + 1)) : null)
  let reg = new RegExp('[?&]' + val + '=([^&#]*)', 'i')
  let res = window.location.href.match(reg)

  if (res && res.length > 1) {
    return decodeURIComponent(res[1])
  }
  return ''
}

export const sendVerCode = (that, type) => {
  let mobile = ''
  let param = {}
  if (that.account) {
    mobile = that.account.replace(/\s+/g, '')
    param = {'LoginId': mobile}
  }
  if (!that.coolDown) {
    let _this = that
    let method = ''
    if (type === ct.SendVeriCodeType.register) {
      method = 'gcwwwifc/requestActivation'
    } else if (type === ct.SendVeriCodeType.changePass) {
      method = 'gcwwwifc/requestPasswordChange'
    } else if (type === ct.SendVeriCodeType.resetPass) {
      method = 'gcwwwifc/requestResetPassword'
    } else if (type === ct.SendVeriCodeType.login) {
      method = 'gcwwwifc/requestLoginVerifyCode'
      mobile = that.userMobile.replace(/\s+/g, '')
      param = {'mobile': mobile}
    }
    that.postRequest(method, param)
      .then((response) => {
        if (response) {
          let style = 'error'
          if (response.data.code === 0) {
            that.coolDown = true
            time(_this)
            that.sendVeriCodeSuccess = true
            style = 'success'
          } else {
            that.coolDown = false
            that.sendCodeText = '发送'
            if (type === ct.SendVeriCodeType.login) {
              // let msg = response.data.message
              let code = response.data.code
              if (code === ct.loginSmsCodeResultStatus.Login_By_SmsCode_Result_New_Customer) {
                _this.$alert('<p style="font-weight: bold";font-size: 1rem;>检测到该手机号为新手机号，请您确认：</p>' +
                  '<p><span style="font-weight: 800">（1）</span> 若您已收到实验报告，但您已更换手机号，请您联系业务员或客服更新手机号后，再使用手机验证码登录本系统查看报告。客服热线：</p>' +
                  '<p style="font-weight: 800;font-size: 1.2rem;color: #409EFF;margin-left: 24px">400-621-0302</p>', '温馨提示', {
                  dangerouslyUseHTMLString: true,
                  showConfirmButton: false
                })
                // _this.$alert('<p style="font-weight: bold";font-size: 1rem;>检测到该手机号为新手机号，请您确认：</p>' +
                //   '<p><span style="font-weight: 800">（1）</span> 若您已收到实验报告，但您已更换手机号，请您联系业务员或客服更新手机号后，再使用手机验证码登录本系统查看报告。客服热线：</p>' +
                //   '<p style="font-weight: 800;font-size: 1.2rem;color: #409EFF;margin-left: 24px">400-621-0302</p>' +
                //   '<p><span style="font-weight: 800">（2）</span> 若您为吉凯新用户，请您打开微信扫描下方淘基因小程序二维码，立即注册。</p>' +
                //   '<img src="static/img/taogene_wxxcx.png" style="width: 200px;margin-left: 24%;">', '温馨提示', {
                //   dangerouslyUseHTMLString: true,
                //   showConfirmButton: false
                // })
              } else if (code === ct.loginSmsCodeResultStatus.Login_By_SmsCode_Result_Multi_CustomerNo) {
                _this.$alert('<p>检测到您有多个账户，请您联系业务员或客服处理，客服热线:</p>' +
                  '<p style="font-weight: 800;font-size: 1.2rem;color: #409EFF;">400-621-0302</p>', '温馨提示', {
                  dangerouslyUseHTMLString: true,
                  showConfirmButton: false
                })
              }
            }
          }
          that.$message({message: response.data.message, type: style})
        }
      })
  }
  let wait = 60
  function time (_this) {
    if (wait === 0) {
      _this.coolDown = false
      _this.sendCodeText = '发送'
      wait = 60
    } else {
      _this.sendCodeText = wait + 's'
      wait--
      setTimeout(function () {
        time(_this)
      }, 1000)
    }
  }
}

export const phoneVeri = (val) => {
  val = val.replace(/\s+/g, '')
  return (/^1[3-9]\d{9}$/.test(val))
}

export const checkNewPass = (_this) => {
  // console.log('checkNewPass')
  if (_this.verCode === '') {
    _this.$message({message: '请输入验证码', type: 'error'})
    return false
  }
  if (_this.reNewPass !== _this.newPass) {
    _this.$message({message: '两次输入不相同', type: 'error'})
    return false
  }
  return true
}

export const operationTips = (_this) => {
  _this.$message({message: '操作成功～', type: 'success'})
}

export const hideOverflow = () => {
  document.body.parentNode.style.overflow = 'hidden'
}

export const getCurrentElement = (selector) => {
  let classElements = document.querySelectorAll(selector)
  for (let i = classElements.length - 1; i >= 0; i--) {
    if (getComputedStyle(classElements[i])['display'] !== 'none') {
      return classElements[i]
    }
  }
}

const getDictVal = (sysDictionaries, id) => {
  let res = {}
  sysDictionaries.forEach(s => {
    if (s.typeID === id) {
      res[s.dictKey] = s.dictValue
    }
  })
  return res
}

const getSelectOptions = (dict, id) => {
  let res = []
  dict.forEach(s => {
    if (s.typeID === id) {
      let obj = {}
      obj.key = s.dictKey
      obj.value = s.dictValue
      res.push(obj)
    }
  })
  return res
}

export const getSysInfo = (res) => {
  setStorage('externalNginxUrl', res.externalNginxUrl)
  setStorage('sysDictionaries', res.sysDictionaries)
  setStorage('dictBoolean', getDictVal(res.sysDictionaries, 10000))
  setStorage('dictUploadType', getDictVal(res.sysDictionaries, 10012))
  setStorage('dictUploadStatus', getDictVal(res.sysDictionaries, 10008))
  setStorage('dictFileCategory', getDictVal(res.sysDictionaries, 10007))
  setStorage('dictInvalidExpire', getDictVal(res.sysDictionaries, 10013))
  setStorage('invalidExpireOptions', getSelectOptions(res.sysDictionaries, 10013))
}

// export const initMenu = (router, store) => {
//   if (store.state.routes.length > 0) {
//     return
//   }
//   getRequest('/config/sysmenu').then(resp=> {
//     if (resp && resp.status === 200) {
//       let fmtRoutes = formatRoutes(resp.data)
//       router.addRoutes(fmtRoutes)
//       store.commit('initMenu', fmtRoutes)
//       store.dispatch('connect')
//     }
//   })
// }

// export const formatRoutes = (routes)=> {
//   let fmRoutes = []
//   routes.forEach(router=> {
//     let {
//       path,
//       component,
//       name,
//       meta,
//       iconCls,
//       children
//     } = router
//     if (children && children instanceof Array) {
//       children = formatRoutes(children)
//     }
//     let fmRouter = {
//       path: path,
//       component(resolve){
//         if (component.startsWith('Home')) {
//           require(['../components/' + component + '.vue'], resolve)
//         } else if (component.startsWith('Emp')) {
//           require(['../components/emp/' + component + '.vue'], resolve)
//         } else if (component.startsWith('Per')) {
//           require(['../components/personnel/' + component + '.vue'], resolve)
//         } else if (component.startsWith('Sal')) {
//           require(['../components/salary/' + component + '.vue'], resolve)
//         } else if (component.startsWith('Sta')) {
//           require(['../components/statistics/' + component + '.vue'], resolve)
//         } else if (component.startsWith('Sys')) {
//           require(['../components/system/' + component + '.vue'], resolve)
//         }
//       },
//       name: name,
//       iconCls: iconCls,
//       meta: meta,
//       children: children
//     }
//     fmRoutes.push(fmRouter)
//   })
//   return fmRoutes
// }



// WEBPACK FOOTER //
// ./src/utils/utils.js